<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="text-2xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row items-center">
                        <router-link :to="{ name: 'projects' }" class="text-cyan-800 hover:text-cyan-500">
                            Projets
                        </router-link>
                        <svg-vue icon="angle-right-b" class="h-6 w-6 fill-current"></svg-vue>
                        {{ project ? project.translatable.name[locale] : '' }}
                        <button type="button" @click.prevent="handleEditSettings">
                            <svg-vue icon="setting" class="h-8 w-8 text-custom-300" />
                        </button>
                        <Loader v-if="isProjectFetchPending" class="m-2 border-2 -red -sm"/>
                    </span>
                    <LangSwitcher/>
                </span>
                <span>
                    <a href="#" @click.prevent="handleCreateBuilding"
                       class="flex items-center px-4 py-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                        Créer un bâtiment
                    </a>
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <div class="m-4">
                <Search
                    v-model="search"
                    @update:modelValue="handleSearchChange"
                />

                <List
                    :items="buildings"
                    :columns="columns"
                    :desc="desc"
                    @editItem="handleEditBuilding"
                    @deleteItem="handleDeleteBuilding"
                    @manageItem="handleManageBuilding"
                    @sortBy="handleSortBy"
                    @dragEnd="handleDragEnd"
                    editable
                    deletable
                    manageable
                    moveable
                >

                    <template #actions="actionsProps">
                        <a v-if="actionsProps.item.adlead_id" href="/adlead" class="text-indigo-600 hover:text-indigo-900 px-2" @click.prevent="handleSync(actionsProps.item)">Sync. w/ Adlead</a>
                    </template>

                </List>

                <Pagination
                    v-if="lastPage > 1"
                    :current_project="currentPage"
                    :last_page="lastPage"
                    @change="handleChangePage"
                />
            </div>
        </div>
    </main>
</template>

<script>
import PageHeader from "../../components/partials/page-header";
import Loader from "../../components/partials/loader";
import LangSwitcher from "../../components/partials/lang-switcher";
import List from "../../components/partials/list"
import Pagination from "../../components/partials/pagination"
import Search from "../../components/partials/search"
import USER_ROLE from "../../enums/user-role";

export default {
    data() {
        return {
            search: null,
            desc: false
        }
    },
    beforeMount() {
        this.$store.dispatch('projects/getSingle', {id: this.$route.params.id, includes: ['buildings', 'categories', 'status', 'settings']})
    },
    computed: {
        isProjectFetchPending() {
            return this.$store.state.projects.isFetchSinglePending
        },
        project() {
            return this.$store.state.projects.single;
        },
        locale() {
            return this.$store.state.config.locale;
        },
        buildings: {
            get() {
                return this.project ? this.project.buildings.data.sort( (buildingA, buildingB) => Number(buildingA.order_column) > Number(buildingB.order_column) ? 1: -1 ) : [];
            },
            set(list) {
                return this.project.buildings.data = list;
            }
        },
        lastPage() {
            return this.$store.state.buildings.pagination.last_page
        },
        currentPage() {
            return this.$store.state.buildings.pagination.current_page
        },
        columns() {
            return {
                order_column: {
                  label: '#'
                },
                name: {
                    sortable: false,
                    label: 'ID'
                },
                ['translatable.description.' + this.locale]: {
                    sortable: true,
                    sortBy: 'description',
                    label: 'Nom'
                },
                adlead_id: {
                    sortable: false,
                    label: 'ID AdLead',
                    sortBy: 'adlead_id'
                },
            }
        },
        authUser() {
            return this.$store.state.auth.auth_user;
        },
        isRoot() {
            if(this.authUser) {
                return Number(this.authUser.role) === Number(USER_ROLE.values.ROOT.description)
            }

            return false
        },
    },
    methods: {
        handleDeleteBuilding(building) {
            this.$store.state.buildings.single = building;
            this.$store.dispatch('modals/open', 'building-delete');
        },
        handleChangePage(page = this.currentPage) {
            this.$store.dispatch('buildings/getList', {
                'page': page,
                'sort_by': this.sort_by,
                'desc': this.desc,
                'search': this.search ? {'name': this.search} : {}
            });
        },
        handleSortBy(type) {
            this.desc = !this.desc;
            this.sort_by = type;

            this.handleChangePage();
        },
        handleSearchChange(search) {
            this.search = search;
            this.handleChangePage();
        },
        handleCreateBuilding() {
            this.$store.dispatch('buildings/resetSingle')
            this.$store.dispatch('modals/open', 'building-save');
        },
        handleEditBuilding(building) {
            this.$store.dispatch('buildings/setSingle', building);
            this.$store.dispatch('modals/open', 'building-save');
        },
        handleManageBuilding(building) {
            this.$router.push({name: 'building-show', params: {id: building.id}})
        },
        handleEditSettings() {
            this.$store.dispatch('modals/open', 'project_settings-save')
        },
        handleDragEnd(buildings) {
            this.$store.dispatch('buildings/move', {movedFields: buildings});
        },
        handleSync(building) {
            this.$store.dispatch('buildings/sync', {id: building.id});
        }
    },
    components: {
        PageHeader,
        Loader,
        LangSwitcher,
        Search,
        List,
        Pagination
    }
}
</script>
